import React from 'react'
import Dot from 'app/React/InspirationUniverse/Dot'

export default function ProductImageSection ({
  imageObj
}) {
  if (typeof imageObj !== 'object' || !imageObj) {
    return null
  }

  return (
    <div className="mtt-iu-product__image-container object-fit">
      <img src={imageObj?.image?.src} alt={imageObj?.image?.alt ?? 'Product Image'}/>
      {imageObj?.markers?.length > 0 && imageObj.markers.map((marker, index) => {
        return <Dot
          key={index}
          x={marker?.percentX}
          y={marker?.percentY}
          title={marker?.title}
          text={marker?.text}
        />
      })}
    </div>
  )
}
